export default __webpack_public_path__ + "static/media/ribbon.55a09fea.png";